export default {
    evaluation: "evaluation",
    survey: "survey",
};
